import { ApiError, handleApiError } from '@/handleApiError'
import { defineStore } from 'pinia'
import helpers from '@/modules/message/helpers'
import api from '@/modules/user/api'
import { t } from '@/plugins/i18n.ts'

interface UserInvitationState {
  loading: boolean
}

const initialState = (): UserInvitationState => {
  return {
    loading: false
  }
}

const useUserInvitation = defineStore('userInvitation', {
  state: () => initialState(),
  actions: {
    async validateMail(mail: string, isAdmin: boolean) {
      return api
        .validateMail(mail, isAdmin)
        .then(({ data }) => {
          return data
        })
        .catch((error: ApiError) => {
          handleApiError(error, {
            customMessage: t('error.invitation')
          })
        })
    },
    async sendInvites(mails: string[]) {
      this.loading = true

      return api
        .sendInvites(mails)
        .then(({ data }) => {
          if (data.invalidEmails?.length != 0) {
            helpers.reportError(t('error.invalidEmail'))
          } else if (data.isAlreadyInvited?.length != 0) {
            helpers.reportError(t('error.alreadyInvited'))
          } else if (data.isAlreadyRegistered?.length != 0) {
            helpers.reportError(t('error.alreadyRegistered'))
          } else {
            helpers.reportSuccess(t('success.invitationSent'))
          }
        })
        .catch((error: ApiError) => {
          handleApiError(
            error,
            {
              customMessage: t('error.invitation')
            },
            {
              errorCode: 403,
              logError: false,
              customMessage: t('error.noAdmin')
            }
          )
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
})

export default useUserInvitation
